import React from "react";
export function highlight(text, keyword) {
    if (keyword === void 0) { keyword = ""; }
    // eslint-disable-next-line no-param-reassign
    keyword = (keyword || "").trim();
    if ((typeof text !== "string" && typeof text !== "number") || !keyword) {
        return text;
    }
    return String(text)
        .split(keyword)
        .map(function (text, index) {
        var key = text + "-" + index;
        if (index >= 1) {
            return (React.createElement("span", { key: key },
                React.createElement("strong", null, keyword),
                text));
        }
        return React.createElement("span", { key: key }, text);
    });
}
//# sourceMappingURL=text-highlight.js.map